import { Button, Stack, Typography } from '@mui/material';
import { useBoundStore } from 'useStore';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';
import useChannelsProductMasterData from '../Queries/ProductMasterChannelsQuery';
import { useMemo } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
const SubmitEditButtons = ({ loading, handleSentData }) => {
	const localChannels = useBoundStore((state) => state.localChannels);

	const setLocalChannels = useBoundStore((state) => state.setLocalChannels);

	const mainCountry = useCurrentMasterCountry();
	const { data: channels } = useChannelsProductMasterData();

	const mainCountryId = mainCountry?.id;

	const filteredChannel = useMemo(() => {
		return (
			channels?.filter((channel) => channel.country_id === mainCountryId) ?? []
		);
	}, [channels, mainCountryId]);

	const channelKeys = useMemo(() => {
		return filteredChannel.map((channel) => channel.marketplace_sname);
	}, [filteredChannel]);

	const transformData = () => {
		return Object.entries(localChannels).map(([sku, selectedChannelKeys]) => {
			const marketplaceKeysSelected = selectedChannelKeys;

			const status = channelKeys.reduce((acc, key) => {
				acc[key] = marketplaceKeysSelected.includes(key);
				return acc;
			}, {});

			return {
				sku,
				status,
				country: mainCountryId,
			};
		});
	};

	const clearButton = () => {
		setLocalChannels({});
	};

	const handleSubmit = () => {
		const data = transformData();
		console.log(data);
		handleSentData(data);
	};
	return (
		<Stack
			direction="row"
			justifyContent="flex-end"
			justifyItems="flex-end"
			spacing={1}
			alignItems="center"
		>
			<Button
				variant="outline"
				onClick={clearButton}
				sx={{
					color: '#354887',
					height: '32px',
					border: '1px solid #354887',
					maxWidth: '107px',
					fontFamily: 'Roboto',
					fontWeight: '500px',
					fontSize: '14px',
				}}
			>
				CANCELAR
			</Button>
			<Button
				variant="contained"
				onClick={handleSubmit}
				sx={{
					fontFamily: 'Roboto',
					fontWeight: '500px',
					fontSize: '14px',
					color: '#ffffff',
					backgroundColor: '#354887',
					height: '32px',
					maxWidth: '167px',
					'&:hover': {
						backgroundColor: '#2c3b6f',
					},
				}}
			>
				GUARDAR CAMBIOS
			</Button>
		</Stack>
	);
};

export default SubmitEditButtons;
